<template>
  <LoaderComponent v-if="loadingData"></LoaderComponent>
  <div  >
    <div v-for="tblRef in tableReference" :key="tblRef.idReference" class="row"   >
        <div class="cellID">{{ tblRef.idReference }}</div>
        <div class="cellDES">{{ tblRef.description }}</div>
    </div>
  </div>
  <MessageComponent v-if="message!=''" :message="message" :messageType="messagetype"></MessageComponent>
</template>

<script>
import MessageComponent from "./MessageComponent.vue";
import api from "../js/apiConsts.js";
import { axiosGet } from "../js/apiService.js";
import LoaderComponent from "./LoaderComponent.vue";
import { getSTRING } from "@/js/utils";
import apiConsts from "../js/apiConsts.js";
export default {
  name: "TableReference",
  components: {
    LoaderComponent,
    MessageComponent
  },
  props: ["lang"],
  data() {
    return {
      language: 0,
      tableReference: null,
      loadingData: false,
      TITOLO: '',
      message: '',
      messagetype: 1
    };
  },
  async mounted() {
    await this.loadTableReference();
    this.TITOLO = getSTRING(this.lang , "TITOLO" , apiConsts.TITOLOAPP);
  },
  methods: {
    async loadTableReference() {
      this.message='';
      this.loadingData = true;
      await axiosGet(api.APIReferences)
        .then((response) => {
            this.loadingData = false;
            let res = response.data;
            this.tableReference = null;
            if (res.success) {
                this.tableReference = res.references;
            }
            else {
              this.message=res.message;
            }
        })
        .catch((err) => {
          this.loadingData = false;
          this.message=err.message;
        });
    },
  },
};
</script>

<style scoped>
.row  {
    display: flex; 
    text-align: left; 
    border: 1px solid grey;
    border-bottom: 1px solid   #00c6c0;;
    min-height: 50px
}
.cellID {
    padding:15px; width: 10%; border-right: 1px solid grey;
}
.cellDES {
    padding:15px; width: 90%; border-right: 1px solid grey;
}

</style>